import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/supervisor_/')({
	loader: async () => {
		throw redirect({ to: '/supervisor/users' });
	},
	component: () => null,
});
